module.exports = __webpack_public_path__ + "static/media/flat-tire.ac044220.svg";